import { render, staticRenderFns } from "./ManageMyQualification.vue?vue&type=template&id=4be78694&scoped=true&"
import script from "./ManageMyQualification.vue?vue&type=script&lang=js&"
export * from "./ManageMyQualification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be78694",
  null
  
)

export default component.exports